"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseType = exports.CourseCohort = exports.CourseLevel = void 0;
var CourseLevel;
(function (CourseLevel) {
    CourseLevel["ADVANCED_DIPLOMA"] = "ADVANCED_DIPLOMA";
    CourseLevel["ASSOCIATE_DEGREE"] = "ASSOCIATE_DEGREE";
    CourseLevel["BACHELOR"] = "BACHELOR";
    CourseLevel["BACHELOR_HONORS"] = "BACHELOR_HONOURS";
    CourseLevel["CERTIFICATE_I"] = "CERTIFICATE_I";
    CourseLevel["CERTIFICATE_II"] = "CERTIFICATE_II";
    CourseLevel["CERTIFICATE_III"] = "CERTIFICATE_III";
    CourseLevel["CERTIFICATE_IV"] = "CERTIFICATE_IV";
    CourseLevel["DIPLOMA"] = "DIPLOMA";
    CourseLevel["DOCTORAL_DEGREE"] = "DOCTORAL_DEGREE";
    CourseLevel["GRADUATE_CERTIFICATE"] = "GRADUATE_CERTIFICATE";
    CourseLevel["GRADUATE_DIPLOMA"] = "GRADUATE_DIPLOMA";
    CourseLevel["HIGHER_DOCTORAL_DEGREE"] = "HIGHER_DOCTORAL_DEGREE";
    CourseLevel["HONOURS_YEAR"] = "HONOURS_YEAR";
    CourseLevel["MASTERS_COURSEWORK"] = "MASTERS_COURSEWORK";
    CourseLevel["MASTERS_RESEARCH"] = "MASTERS_RESEARCH";
    CourseLevel["SENIOR_SECONDARY_CERTIFICATE_OF_EDUCATION"] = "SENIOR_SECONDARY_CERTIFICATE_OF_EDUCATION";
    CourseLevel["STATEMENT_OF_ATTAINMENT"] = "STATEMENT_OF_ATTAINMENT";
    CourseLevel["UNDERGRADUATE_CERTIFICATE"] = "UNDERGRADUATE_CERTIFICATE";
})(CourseLevel = exports.CourseLevel || (exports.CourseLevel = {}));
var CourseCohort;
(function (CourseCohort) {
    CourseCohort["DOMESTIC"] = "DOMESTIC";
    CourseCohort["INTERNATIONAL"] = "INTERNATIONAL";
})(CourseCohort = exports.CourseCohort || (exports.CourseCohort = {}));
var CourseType;
(function (CourseType) {
    CourseType["SINGLE"] = "SINGLE";
    CourseType["DOUBLE"] = "DOUBLE";
})(CourseType = exports.CourseType || (exports.CourseType = {}));
//# sourceMappingURL=CourseCommon.js.map